// Progreso de peso puramente empírico: nunca prescribe un ritmo, solo
// describe el ritmo real observado en los propios registros del usuario,
// y lo compara con la fecha objetivo que el propio usuario eligió.
export function computeWeightProgress(logs, targetDate, goalWeight) {
  if (!logs || logs.length < 2) return { phase: 'registration' };

  const first = logs[0];
  const daysSinceFirst = (new Date(logs[logs.length - 1].logged_at) - new Date(first.logged_at)) / 86400000;
  if (daysSinceFirst < 30) return { phase: 'registration' };

  // Regresión lineal (mínimos cuadrados) sobre todos los puntos — más robusta
  // ante un pesaje puntual atípico que una pendiente simple primero-vs-último.
  const xs = logs.map(l => (new Date(l.logged_at) - new Date(first.logged_at)) / 86400000);
  const ys = logs.map(l => l.weight);
  const n = xs.length;
  const meanX = xs.reduce((a, b) => a + b, 0) / n;
  const meanY = ys.reduce((a, b) => a + b, 0) / n;
  const num = xs.reduce((s, x, i) => s + (x - meanX) * (ys[i] - meanY), 0);
  const den = xs.reduce((s, x) => s + (x - meanX) ** 2, 0);
  const slope = den === 0 ? 0 : num / den; // kg/día, puramente empírico

  if (!targetDate || !goalWeight) return { phase: 'trend_only', slope };

  const daysRemaining = (new Date(targetDate) - new Date()) / 86400000;
  if (daysRemaining <= 0) return { phase: 'trend_only', slope };

  const projected = ys[ys.length - 1] + slope * daysRemaining;
  return { phase: 'on_pace_check', slope, onPace: projected <= goalWeight + 0.5, projected };
}
